<template>


<div class="col">
            <div class="row mb-3" v-if="showFilters">
              <div class="col-12 col-md-8 mb-2 mb-md-0">
                <input
                  class="form-control"
                  placeholder="Islerde ara..."
                  :value="isler.arananKelime"
                  @input="isAramaDegistir($event.target.value)"
                />
              </div>
              <div class="col-12 col-md-4 mt-2 mt-md-0">
                <select class="form-select" :value="isler.sayfadaKayit" @change="islerSayfadaKayitDegistir(Number($event.target.value))">
                  <option :value="5">5 adet</option>
                  <option :value="10">10 adet</option>
                  <option :value="20">20 adet</option>
                  <option :value="30">30 adet</option>
                </select>
              </div>
            </div>
            <div class="row">
     
              

<div 
          v-for="is in paginatedisler" 
          :key="is.id" 
          class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3"
        >
          <div 
            :class="['card', 'h-100', 'compact-is-card', seciliIs && seciliIs.id === is.id ? 'isler-ring-selected' : 'border-0', 'shadow-sm']"
            @click="kartTikla(is)"
            style="cursor: pointer;"
          >
            <!-- Durum çubuğu -->
            <div :class="['card-status-top', getDurumColorClass(is.durum)]"></div>
            
            <div class="card-body p-3">
              <!-- İş Adı -->
              <h6 class="card-title mb-2 text-truncate">
                <router-link v-if="yetki_kontrol('is_goster') && !showDetailModal" :to="'/isler/' + is.id" @click.stop class="text-decoration-none">
                  {{ is.ad }}
                </router-link>
                <span v-else>{{ is.ad }}</span>
              </h6>

              <!-- Müşteri ve İş Türü -->
              <div class="text-small text-muted mb-2">
                <div class="text-truncate">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" class="me-1">
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                  </svg>
                  {{ musteriBilgileri(is.musteri).unvan || 'Bilinmeyen' }}
                </div>
                <div class="text-truncate">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" class="me-1">
                    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>
                  </svg>
                  {{ isturBilgileri(is.istur).ad || 'Bilinmeyen' }}
                </div>
              </div>

              <!-- Tarihler -->
              <div class="text-extra-small text-muted mb-2">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16" class="me-1">
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z"/>
                  </svg>
                  {{ formatTarihKisa(is.baslamatarih) }} - {{ formatTarihKisa(is.bitistarih) }}
                </div>
              </div>

              <!-- Badges -->
              <div class="d-flex flex-wrap gap-1 mb-2">
                <span :class="getAciliyetBadgeClass(is.aciliyet)" style="font-size: 0.7rem;">
                  {{ getAciliyetAdi(is.aciliyet) }}
                </span>
                <span class="badge bg-outline-primary" style="font-size: 0.7rem;">
                  {{ getDurumAdi(is.durum) }}
                </span>
              </div>

              <!-- Kullanıcılar (Avatarlar) -->
              <div class="d-flex align-items-center mb-2" v-if="is.kullanicilar && is.kullanicilar.length > 0">
                <div class="d-flex" style="margin-left: -4px;">
                  <span 
                    v-for="(kulId, index) in is.kullanicilar.split(',').slice(0, 3)" 
                    :key="kulId"
                    class="avatar-circle"
                    :style="{marginLeft: index > 0 ? '-8px' : '0', zIndex: 10 - index}"
                    :title="kullaniciBilgileri(kulId).ad + ' ' + kullaniciBilgileri(kulId).soyad"
                  >
                    {{ getInitials(kullaniciBilgileri(kulId)) }}
                  </span>
                  <span 
                    v-if="is.kullanicilar.split(',').length > 3"
                    class="avatar-circle"
                    style="margin-left: -8px; background-color: #6c757d;"
                  >
                    +{{ is.kullanicilar.split(',').length - 3 }}
                  </span>
                </div>
              </div>

              <!-- Aksiyon Butonları -->
              <div class="d-flex gap-1 justify-content-end mt-auto">
                <router-link 
                  v-if="yetki_kontrol('is_goster')" 
                  :to="'/isler/' + is.id"
                  class="btn btn-sm btn-icon btn-outline-primary"
                  @click.stop
                  title="Detay"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2.47466 10.8418C2.15365 10.3203 2.15365 9.67971 2.47466 9.15822C3.49143 7.50643 6.10818 4 10 4C13.8918 4 16.5086 7.50644 17.5253 9.15822C17.8464 9.67971 17.8464 10.3203 17.5253 10.8418C16.5086 12.4936 13.8918 16 10 16C6.10818 16 3.49143 12.4936 2.47466 10.8418Z"></path>
                    <path d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"></path>
                  </svg>
                </router-link>

                <button  
                  v-if="!readonly && yetki_kontrol('isdurum_duzenle')" 
                  @click.stop="duzenle(is)"  
                  class="btn btn-sm btn-icon btn-outline-primary"
                  title="Düzenle"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 2L5.5 2C4.09554 2 3.39331 2 2.88886 2.33706C2.67048 2.48298 2.48298 2.67048 2.33706 2.88886C2 3.39331 2 4.09554 2 5.5L2 14.5C2 15.9045 2 16.6067 2.33706 17.1111C2.48298 17.3295 2.67048 17.517 2.88886 17.6629C3.39331 18 4.09554 18 5.5 18L14.5 18C15.9045 18 16.6067 18 17.1111 17.6629C17.3295 17.517 17.517 17.3295 17.6629 17.1111C18 16.6067 18 15.9045 18 14.5L18 11"></path>
                    <path d="M15.4978 3.06224C15.7795 2.78052 16.1616 2.62225 16.56 2.62225C16.9585 2.62225 17.3405 2.78052 17.6223 3.06224C17.904 3.34396 18.0623 3.72605 18.0623 4.12446C18.0623 4.52288 17.904 4.90497 17.6223 5.18669L10.8949 11.9141L8.06226 12.6223L8.7704 9.78966L15.4978 3.06224Z"></path>
                  </svg>
                </button>

                <button 
                  v-if="!readonly && yetki_kontrol('is_sil')" 
                  @click.stop="sil(is.id)"
                  class="btn btn-sm btn-icon btn-outline-danger"
                  title="Sil"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 5V14.5C4 15.9045 4 16.6067 4.33706 17.1111C4.48298 17.3295 4.67048 17.517 4.88886 17.6629C5.39331 18 6.09554 18 7.5 18H12.5C13.9045 18 14.6067 18 15.1111 17.6629C15.3295 17.517 15.517 17.3295 15.6629 17.1111C16 16.6067 16 15.9045 16 14.5V5"></path>
                    <path d="M14 5L13.9424 4.74074C13.6934 3.62043 13.569 3.06028 13.225 2.67266C13.0751 2.50368 12.8977 2.36133 12.7002 2.25164C12.2472 2 11.6734 2 10.5257 2L9.47427 2C8.32663 2 7.75281 2 7.29981 2.25164C7.10234 2.36133 6.92488 2.50368 6.77496 2.67266C6.43105 3.06028 6.30657 3.62044 6.05761 4.74074L6 5"></path>
                    <path d="M2 5H18M12 9V13M8 9V13"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>


 </div>
            <div class="row mt-5">
              <div class="col-12 text-center">
                <!-- Sayfalama -->
                <nav>
                  <ul class="pagination">
                    <li class="page-item" :class="{ active: page === isler.seciliSayfa }" v-for="page in pages" :key="page">
                      <a class="page-link" @click="islerSayfaDegistir(page)">{{
                        page
                      }}</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="modal fade modal-close-out show" style="display: block;" v-if="showDetailModal && detailModal">
              <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">İş Detayı</h5>
                    <button type="button" class="btn-close" @click="detailModal = false"></button>
                  </div>
                  <div class="modal-body" v-if="seciliDetayIs">
                    <div class="row g-3">
                      <div class="col-12">
                        <div class="fw-bold fs-5">{{ seciliDetayIs.ad }}</div>
                        <div class="text-muted">{{ seciliDetayIs.aciklama || "-" }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">Müşteri</div>
                        <div>{{ musteriBilgileri(seciliDetayIs.musteri).unvan || "-" }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">İş Türü</div>
                        <div>{{ isturBilgileri(seciliDetayIs.istur).ad || seciliDetayIs.istur || "-" }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">Durum</div>
                        <div>{{ getDurumAdi(seciliDetayIs.durum) }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">Aciliyet</div>
                        <div>{{ getAciliyetAdi(seciliDetayIs.aciliyet) }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">Başlama</div>
                        <div>{{ formatTarihKisa(seciliDetayIs.baslamatarih) || "-" }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted text-small">Bitiş</div>
                        <div>{{ formatTarihKisa(seciliDetayIs.bitistarih) || "-" }}</div>
                      </div>
                      <div class="col-12">
                        <div class="text-muted text-small">Atanan Kullanıcılar</div>
                        <div>{{ kullaniciListesi(seciliDetayIs.kullanicilar) }}</div>
                      </div>
                      <div class="col-12">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div class="text-muted text-small">Yapılan Çalışmalar</div>
                          <span class="badge bg-outline-primary">{{ modalCalismalar.length }} adet</span>
                        </div>
                        <div v-if="calismaYukleniyor" class="text-muted text-small">Çalışmalar yükleniyor...</div>
                        <div v-else-if="modalCalismalar.length === 0" class="text-muted text-small">Bu işe ait çalışma bulunamadı.</div>
                        <div v-else class="row g-2">
                          <div class="col-6 col-md-4" v-for="(calisma, index) in modalCalismalar.slice(0, 6)" :key="`${calisma.id || index}-calisma`">
                            <a :href="$globalVariable.uploadUrl + calisma.dosya" target="_blank" class="text-decoration-none">
                              <div class="card h-100">
                                <img :src="$globalVariable.uploadUrl + calisma.dosya" @error="$globalVariable.varsayilanGorsel" class="card-img-top sh-10" />
                                <div class="card-body p-2">
                                  <div class="text-small fw-semibold text-truncate">{{ calisma.ad || 'Çalışma' }}</div>
                                  <div class="text-extra-small text-muted">{{ formatTarihKisa(calisma.olusturma_tarih) || '-' }}</div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <router-link
                      v-if="yetki_kontrol('is_goster') && seciliDetayIs && seciliDetayIs.id"
                      :to="'/isler/' + seciliDetayIs.id"
                      class="btn btn-outline-primary btn-sm"
                      @click="detailModal = false"
                    >
                      İş Detayına Git
                    </router-link>
                    <button type="button" class="btn btn-secondary btn-sm" @click="detailModal = false">Kapat</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

  
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import { globalVariable } from '@/services/globalVariable';
import { formatTarihKisa } from '@/services/globalVariable';

export default {
  props: {

    isler:{
      type: Array,
      required: true
    },
    duzenle: Function,
    formKaydetSonrasi: Function,
    tur:String,
    readonly: {
      type: Boolean,
      default: false
    },
    seciliIs: Object,
    showFilters: {
      type: Boolean,
      default: false
    },
    showDetailModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      kullanicilar: [],
      musteriler: [],
      isturler: [],
      durumlar: [
                { id: 'musteriyeni', ad: 'Müşteri İsteği' },
                { id: 'ajansyeni', ad: 'Yeni' },
                { id: 'yeni', ad: 'Yeni' },
                { id: 'hazirlaniyor', ad: 'Hazırlanıyor' },
                { id: 'ajansonaybekliyor', ad: 'Ajans Onayı Bekliyor' },
                { id: 'musterionaybekliyor', ad: 'Müşteri Onayı Bekliyor' },
                { id: 'revizeli', ad: 'Revizeli' },
                { id: 'tamamlandi', ad: 'Tamamlandi' },
                { id: 'iptal', ad: 'İptal Edildi' },
            ],
      aciliyetler: [
        { id: '0', ad: 'Beklemede' },
        { id: '1', ad: 'Normal' },
        { id: '2', ad: 'Acil' },
        { id: '3', ad: 'Çok Acil' }
      ],
      showDosyaModal: false,
      modalDosyalar: [],
      showCalismaModal: false,
      modalCalismalar: [],
      calismaYukleniyor: false,
      $globalVariable: globalVariable,
      detailModal: false,
      seciliDetayIs: null,
    };
  },
  created() {
    this.kullanicilarGetir(); 
    this.musterilerGetir(); 
    this.isturlerGetir(); 
  },
  computed: {
    filteredisler() {
      const arananKelime = (this.isler?.arananKelime || "").toLowerCase().trim();
      const aktifFiltre = this.isler?.filtreCard || "tumisler";

      if (Array.isArray(this.isler)) {
        return this.isler.filter((is) => {

        
          const tumIsler = aktifFiltre === "tumisler";

          const buHaftaIslerFiltre =
            (is.id && aktifFiltre=='buhafta' && Array.isArray(this.isler.buHaftakiIslerIdler) && this.isler.buHaftakiIslerIdler.includes(is.id));

          
          const revizeliIslerFiltre =
            (is.id && aktifFiltre=='revizeli' && Array.isArray(this.isler.revizeliIsIdler) && this.isler.revizeliIsIdler.includes(is.id));


          const durumFiltre =
            (is.durum  && aktifFiltre!='buhafta' && aktifFiltre!='tumisler' && is.durum == aktifFiltre);

        
          const digerFiltreler =
            !arananKelime ||
            (is.ad && is.ad.toLowerCase().includes(arananKelime)) ||
            (is.uruntur && is.uruntur.toLowerCase().includes(arananKelime)) ||
            (is.aciklama && is.aciklama.toLowerCase().includes(arananKelime));

          // Eğer filtreCard 'devamisler' ise, sadece tamamlanmayan ve iptal olmayan işler
          if (aktifFiltre === 'devamisler') {
            return is.durum !== 'tamamlandi' && is.durum !== 'iptal' && digerFiltreler;
          }

          return (tumIsler || durumFiltre || buHaftaIslerFiltre || revizeliIslerFiltre ) && digerFiltreler ;
        });
      }
      if (this.isler && Array.isArray(this.isler.tumu)) {
        return this.isler.tumu.filter((is) => {

        
          const tumIsler = aktifFiltre === "tumisler";

          const buHaftaIslerFiltre =
            (is.id && aktifFiltre=='buhafta' && Array.isArray(this.isler.buHaftakiIslerIdler) && this.isler.buHaftakiIslerIdler.includes(is.id));

          
          const revizeliIslerFiltre =
            (is.id && aktifFiltre=='revizeli' && Array.isArray(this.isler.revizeliIsIdler) && this.isler.revizeliIsIdler.includes(is.id));


          const durumFiltre =
            (is.durum  && aktifFiltre!='buhafta' && aktifFiltre!='tumisler' && is.durum == aktifFiltre);

        
          const digerFiltreler =
            !arananKelime ||
            (is.ad && is.ad.toLowerCase().includes(arananKelime)) ||
            (is.uruntur && is.uruntur.toLowerCase().includes(arananKelime)) ||
            (is.aciklama && is.aciklama.toLowerCase().includes(arananKelime));

          // Eğer filtreCard 'devamisler' ise, sadece tamamlanmayan ve iptal olmayan işler
          if (aktifFiltre === 'devamisler') {
            return is.durum !== 'tamamlandi' && is.durum !== 'iptal' && digerFiltreler;
          }

          return (tumIsler || durumFiltre || buHaftaIslerFiltre || revizeliIslerFiltre ) && digerFiltreler ;
        });
      }
      return [];
    },
      
    paginatedisler() {
      const start = (this.isler.seciliSayfa - 1) * this.isler.sayfadaKayit;
      const end = start + this.isler.sayfadaKayit;
      return this.filteredisler.slice(start, end);
    },
    isler_toplamSayfa() {
      const totalFilteredUsers = this.filteredisler.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.isler.sayfadaKayit), 1);
      if (this.isler.seciliSayfa > maxPage) {
        this.islerSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
      return Array.from({ length: this.isler_toplamSayfa }, (_, index) => index + 1);
    },
  },
  methods: {
    formatTarihKisa,
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
   
    getDurumAdi(durumId) {
            const durum = this.durumlar.find(item => item.id === durumId);
            return durum ? durum.ad : 'Bilinmeyen Durum';
        },

        // Bu metodu ekleyin
  getDurumColorClass(durum) {
    const colorMap = {
      'musteriyeni': 'bg-info',
      'ajansyeni': 'bg-primary',
      'yeni': 'bg-primary',
      'hazirlaniyor': 'bg-warning',
      'ajansonaybekliyor': 'bg-secondary',
      'musterionaybekliyor': 'bg-secondary',
      'revizeli': 'bg-danger',
      'tamamlandi': 'bg-success',
      'iptal': 'bg-dark'
    };
    return colorMap[durum] || 'bg-primary';
  },

  // Bu metodu da ekleyin
  getInitials(kullanici) {
    if (!kullanici || !kullanici.ad) return '?';
    const ad = kullanici.ad.charAt(0).toUpperCase();
    const soyad = kullanici.soyad ? kullanici.soyad.charAt(0).toUpperCase() : '';
    return ad + soyad;
  },
    getAciliyetAdi(aciliyetId) {
      const aciliyet = this.aciliyetler.find(item => item.id === aciliyetId);
      return aciliyet ? aciliyet.ad : 'Normal';
    },

    getAciliyetBadgeClass(aciliyetId) {
      const baseClass = 'badge me-1 ';
      switch(aciliyetId) {
        case '0':
          return baseClass + 'bg-white text-muted'; // Beklemede - Gri
        case '1':
          return baseClass + 'bg-info'; // Normal - Mavi
        case '2':
          return baseClass + 'bg-warning text-dark'; // Acil - Sarı
        case '3':
          return baseClass + 'bg-danger'; // Çok Acil - Kırmızı
        default:
          return baseClass + 'bg-primary'; // Varsayılan
      }
    },

    async sil(isId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("isler/sil/" + isId);
          this.$toast.success("Kullanıcı Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    islerSayfaDegistir(page) {
      this.$emit('update:isler',{
      ...this.isler,
      seciliSayfa: page
    });
    },
    islerSayfadaKayitDegistir(value) {
      this.$emit('update:isler',{
      ...this.isler,
      sayfadaKayit: value
    });
      this.islerSayfaDegistir(1);
    },
    isAramaDegistir(value) {
      this.$emit('update:isler', {
        ...this.isler,
        arananKelime: value,
        seciliSayfa: 1,
      });
    },
    kartTikla(is) {
      if (this.showDetailModal) {
        this.seciliDetayIs = is;
        this.detayCalismalariGetir(is.id);
        this.detailModal = true;
        return;
      }
      this.$emit("seciliIs", is);
    },
    async detayCalismalariGetir(isId) {
      this.calismaYukleniyor = true;
      this.modalCalismalar = [];
      try {
        const response = await axiosCustom.get(`isler/detay/${isId}`);
        this.modalCalismalar = response?.data?.calismalar || [];
      } catch (error) {
        this.modalCalismalar = [];
      } finally {
        this.calismaYukleniyor = false;
      }
    },
    kullaniciListesi(kullaniciDegeri) {
      if (!kullaniciDegeri) return "-";
      const ids = String(kullaniciDegeri).split(",").map((id) => id.trim()).filter(Boolean);
      if (!ids.length) return "-";
      const adlar = ids.map((id) => {
        const kisi = this.kullaniciBilgileri(id);
        return kisi && kisi.ad ? `${kisi.ad} ${kisi.soyad || ""}`.trim() : `#${id}`;
      });
      return adlar.join(", ");
    },

    async kullanicilarGetir() {
      try {
        const response = await axiosCustom.get("kullanicilar");
        this.kullanicilar = response.data;
      } catch (error) {
        console.error("kullanicilar alma hatası: ", error);
      }
    },
    kullaniciBilgileri(id) {
      return this.kullanicilar.find((kullanici) => kullanici.id === id) || {};
    },
    async musterilerGetir() {
      try {
        const response = await axiosCustom.get("musteriler"); 
        this.musteriler = response.data;
      } catch (error) {
        console.error("musteriler alma hatası: ", error);
      }
    },
    musteriBilgileri(id) {
      return this.musteriler.find((musteri) => musteri.id === id) || {};
    },
    async isturlerGetir() {
      try {
        const response = await axiosCustom.get("isturler"); 
        this.isturler = response.data;
      } catch (error) {
        console.error("istürler alma hatası: ", error);
      }
    },
    isturBilgileri(id) {
      return this.isturler.find((musteri) => musteri.id === id) || {};
    },
   
  },
};
</script>

<style scoped>
.isler-ring-selected {
  border: 2px solid #cf2637  !important; /* Bootstrap primary */
  transition: border 0.2s;
}

.isler-ring-selected {
  border: 2px solid #cf2637 !important;
  transition: border 0.2s;
}

.compact-is-card {
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.compact-is-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}

.card-status-top {
  height: 4px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.avatar-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.btn-icon {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>